<div id="layout-config" class="layout-config" [ngClass]="{'layout-config-active': appMain.configActive}" (click)="appMain.onConfigClick($event)">
    <a style="cursor: pointer" id="layout-config-button" class="layout-config-button" (click)="onConfigButtonClick($event)">
        <i *ngIf="!visible" class="pi pi-moon"></i>
        <i *ngIf="visible" class="pi pi-sun"></i>
    </a>
</div>
